import { Scene, FullScreenBackgroundFill } from "onearm";
import { Signal } from "typed-signals";
import { BetsLadderControl } from "../controllers/BetsLadderControl.js";
import { formatCurrency } from "../../utils/formatCurrency.js";

export class BetSettingsScene extends Scene {
    constructor(parameters) {
        super({ layer: "popups", name: "BetSettingsScene", ...parameters });
    }

    create(options) {
        super.create(options);

        const { screen, betsLadder, bet, linesCount } = options;

        this.onPressClose = new Signal();

        this.fill = this.addChildAt(
            new FullScreenBackgroundFill({
                fullScreenZone: screen.zone.fullScreen,
                color: 0x000000,
                alpha: 0.8,
            }),
        0);

        this.betControl = new BetsLadderControl(betsLadder);
        this.onTotalBetChanged = this.betControl.onTotalBetChanged;

        this.betControl.onValuesChanged.connect((values) => {
            this._updateDisplays(values);
        });

        this.betControl.setTotalBet(bet);

        if (typeof linesCount === "number") {
            this.layout.forAll("PopupTitle", (title) => {
                title.text = `BETTING ON ${linesCount} LINES`;
            });
        }

        this.layout.forAll("CloseButton", (closeButton) => {
            closeButton.onPress.connect(() => this.onPressClose.emit());
        });

        this.layout.forAll("BetMaxButton", (btn) => {
            btn.onPress.connect(() => this.betControl.setBetMax());
        });

        this.layout.forAll("BetPanel.MinusButton", (btn) => {
            btn.onPress.connect(() => this.betControl.previousBetValue());
        });
        this.layout.forAll("BetPanel.PlusButton", (btn) => {
            btn.onPress.connect(() => this.betControl.nextBetValue());
        });

        this.layout.forAll("CoinPanel.MinusButton", (btn) => {
            btn.onPress.connect(() => this.betControl.previousCoinValue());
        });
        this.layout.forAll("CoinPanel.PlusButton", (btn) => {
            btn.onPress.connect(() => this.betControl.nextCoinValue());
        });

        this.layout.forAll("TotalBetPanel.MinusButton", (btn) => {
            btn.onPress.connect(() => this.betControl.previousTotalBet());
        });
        this.layout.forAll("TotalBetPanel.PlusButton", (btn) => {
            btn.onPress.connect(() => this.betControl.nextTotalBet());
        });
    }

    _updateDisplays({ bet, coinValue, totalBet }) {
        this.layout.forAll("BetPanel.ValueContainer.value", (text) => {
            text.text = String(bet);
        });
        this.layout.forAll("CoinPanel.ValueContainer.value", (text) => {
            text.text = formatCurrency(coinValue);
        });
        this.layout.forAll("TotalBetPanel.ValueContainer.value", (text) => {
            text.text = formatCurrency(totalBet);
        });
    }
}
